import styled from 'styled-components';
import { BodyRegularS } from '../../../../styles/globals';
import { ITheme } from '../../../../styles/theme';

interface ICompareFilterTileCont {
  theme: ITheme;
  selected?: boolean;
}
export const CompareFilterTileCont = styled.div<ICompareFilterTileCont>`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 48px;
  ${({ theme, selected }: ICompareFilterTileCont) => `
    padding:0 ${theme.layout.spacing.mega} 0 ${theme.layout.spacing.mili};
    background: ${selected ? theme.colors.secondary[30] : theme.colors.neutral.primary[0]};
    
    &:hover {
     background: ${theme.colors.primary[10]};
    }
  `}
`;

export const CheckCont = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  right: 24px;
`;

export const TileContent = styled(BodyRegularS)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
